import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import Login from "./app/pages/login/Login";
import SignUp from "./app/pages/signup/SignUp";
import CustomerHome from "./app/pages/investor/home/Home";
import OwnerHome from "./app/pages/propertyOwner/home/Home";
import PropertyInvestmentDetails from "./app/pages/investor/propertyDetails/PropertyDetails";
import Otp from "./app/pages/otp/Otp";
import AdminLogin from "./app/pages/admin/login/AdminLogin";
import AdminHome from "./app/pages/admin/home/AdminHome";
import PropertyOwners from "./app/pages/admin/owners/PropertyOwners";
import Investors from "./app/pages/admin/investors/Investors";
import AdminProperties from "./app/pages/admin/properties/AdminProperties";
import ViewProperty from "./app/pages/propertyOwner/viewproperty/ViewProperty";
import UserPortFolio from "./app/pages/investor/userPortFolio/UserPortFolio";
import LandingPage from "./app/landingPage/LandingPage";
import InvestorPortfolioDetails from "./app/pages/investor/portfolioOverview/investorPortfolioDetails/InvestorPortfolioDetails";
import SellBlocks from "./app/pages/investor/sellBlocks/SellBlocks";
import CustomerPersonal from "./app/pages/signup/customer/CustomerPersonal";
import AdminPersonal from "./app/pages/signup/agent/AdminPersonal";
import CustomerPreferences from "./app/pages/signup/customer/CustomerPreferences";
import VerifyOtp from "./app/pages/signup/verifyOtp/VerifyOtp";
import OwnerDetailsPending from "./app/pages/signup/agent/ownerDetailsPending/OwnerDetailsPending";
import InvestorDetailsPending from "./app/pages/signup/customer/investorDetailsPending/InvestorDetailsPending";

const App = () => {
  const token = localStorage.getItem("rwatoken");
  const userRole = localStorage.getItem("userRole");

  const isLoggedIn = !!token;

  const getHomeRoute = () => {
    switch (userRole) {
      case "customer":
        return "/customer/home";

      case "owner":
        return "/agent/home";

      case "admin":
        return "/mainAdmin/home";

      default:
        return "/login";
    }
  };

  const ProtectedRoute = ({ children, allowedRole }) => {
    const token = localStorage.getItem("rwatoken");
    const role = localStorage.getItem("userRole");

    // Not logged in
    if (!token) {
      return <Navigate to="/login" replace />;
    }

    // Logged in but trying to access another role's page
    if (allowedRole && role !== allowedRole) {
      return <Navigate to={getHomeRoute()} replace />;
    }

    return children;
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* ================= PUBLIC ================= */}

        <Route
          path="/login"
          element={
            isLoggedIn ? <Navigate to={getHomeRoute()} replace /> : <Login />
          }
        />

        <Route
          path="/home"
          element={
            isLoggedIn ? <Navigate to={getHomeRoute()} replace /> : <LandingPage />
          }
        />

        <Route
          path="/signup"
          element={
            isLoggedIn ? <Navigate to={getHomeRoute()} replace /> : <SignUp />
          }
        />

        <Route
          path="/mainAdmin/login"
          element={
            isLoggedIn ? (
              <Navigate to={getHomeRoute()} replace />
            ) : (
              <AdminLogin />
            )
          }
        />
         <Route
          path="/customer/register/personalInfo"
          element={
               isLoggedIn ? <Navigate to={getHomeRoute()} replace /> : <CustomerPersonal />
          }
        />
        <Route
          path="/register/verify-otp"
          element={
               isLoggedIn ? <Navigate to={getHomeRoute()} replace /> : <VerifyOtp />
          }
        />
        <Route
          path="/agent/register/personalInfo"
          element={
               isLoggedIn ? <Navigate to={getHomeRoute()} replace /> : <AdminPersonal />
          }
        />
        <Route
          path="/customer/register/complete-registration"
          element={
               isLoggedIn ? <Navigate to={getHomeRoute()} replace /> : <InvestorDetailsPending />
          }
        />
        <Route
          path="/agent/register/complete-registration"
          element={
               isLoggedIn ? <Navigate to={getHomeRoute()} replace /> : <OwnerDetailsPending />
          }
        />

        <Route
          path="/otp"
          element={
            isLoggedIn ? <Navigate to={getHomeRoute()} replace /> : <Otp />
          }
        />
         <Route
          path="/customer/register/complete-details"
          element={
            isLoggedIn ? <Navigate to={getHomeRoute()} replace /> : <CustomerPreferences />
          }
        />

        {/* ================= CUSTOMER ================= */}

        <Route
          path="/customer/home"
          element={
            <ProtectedRoute allowedRole="customer">
              <CustomerHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/property/details"
          element={
            <ProtectedRoute allowedRole="customer">
              <UserPortFolio />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/portfolio/details"
          element={
            <ProtectedRoute allowedRole="customer">
              <InvestorPortfolioDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/portfolio/sell"
          element={
            <ProtectedRoute allowedRole="customer">
              <SellBlocks />
            </ProtectedRoute>
          }
        />
       

        <Route
          path="/property-details/:propertyId"
          element={
            <ProtectedRoute allowedRole="customer">
              <PropertyInvestmentDetails />
            </ProtectedRoute>
          }
        />

        {/* ================= OWNER ================= */}

        <Route
          path="/agent/home"
          element={
            <ProtectedRoute allowedRole="owner">
              <OwnerHome />
            </ProtectedRoute>
          }
        />

        <Route
          path="/"
          element={
            <Navigate to={isLoggedIn ? getHomeRoute() : "/home"} replace />
          }
        />

        {/* ================= FALLBACK ================= */}

        <Route
          path="*"
          element={
            <Navigate to={isLoggedIn ? getHomeRoute() : "/home"} replace />
          }
        />
        <Route
          path="/mainAdmin/home"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminHome />
            </ProtectedRoute>
          }
        />

        <Route
          path="/mainAdmin/properties"
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminProperties />
            </ProtectedRoute>
          }
        />

        <Route
          path="/mainAdmin/investors"
          element={
            <ProtectedRoute allowedRole="admin">
              <Investors />
            </ProtectedRoute>
          }
        />

        <Route
          path="/mainAdmin/owners"
          element={
            <ProtectedRoute allowedRole="admin">
              <PropertyOwners />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/property/view/:propertyId"
          element={
            <ProtectedRoute allowedRole="owner">
              <ViewProperty />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;